import { useMutation } from "@apollo/client";

import mutationGQL from "@/Apollo/mutation/createOrUpdateBankAccount.graphql";
import meGQL from "@/Apollo/query/me.graphql";

const useCreateOrUpdateBankAccount = () => {
  return useMutation(mutationGQL, { refetchQueries: [meGQL] });
};

export default useCreateOrUpdateBankAccount;
